/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Cuddly_Mallard_ExhaleInputs */

const fr_shy_cuddly_mallard_exhale = /** @type {(inputs: Shy_Cuddly_Mallard_ExhaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue sur l'app de la Box`)
};

/**

* @param {Shy_Cuddly_Mallard_ExhaleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const shy_cuddly_mallard_exhale = /** @type {((inputs?: Shy_Cuddly_Mallard_ExhaleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Cuddly_Mallard_ExhaleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_shy_cuddly_mallard_exhale(inputs)
});